import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React from "react";
import { B as Box, c as ce } from "./Grid-CcQKdsgp.js";
import { useDisclosureState, useDisclosureGroupState } from "@react-stately/disclosure";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { useId, mergeProps } from "@react-aria/utils";
import { useFocusRing } from "@react-aria/focus";
const SvgArrowRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
const accordionStyles = ce({
  base: "transition-transform cursor-pointer ",
  variants: {
    variant: {
      primary: "bg-[var(--colors-surface-neutral-default)]",
      secondary: ""
    },
    isDisabled: {
      true: "cursor-default",
      false: ""
    }
  },
  defaultVariants: {
    isExpanded: false,
    variant: "primary"
  }
});
const accordionArrowStyles = ce({
  base: "transition-transform  ",
  variants: {
    variant: {
      primary: "",
      secondary: ""
    },
    isExpanded: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    { variant: "primary", isExpanded: true, class: "-rotate-90" },
    { variant: "primary", isExpanded: false, class: "rotate-0" },
    { variant: "secondary", isExpanded: true, class: "-rotate-90" },
    { variant: "secondary", isExpanded: false, class: "rotate-90" }
  ],
  defaultVariants: {
    variant: "primary",
    isExpanded: false
  }
});
const DefaultHeadingWrapper = (wrapperProps) => /* @__PURE__ */ jsx(Flex, { justify: "space-between", align: "center", p: 0, m: 0, children: wrapperProps.children });
const DEFAULT_SPACING_PADDING = [24, 24, 24, 24];
const AccordionItem = (props) => {
  var _a, _b, _c;
  const {
    id: propId,
    title,
    children,
    isExpanded: propIsExpanded,
    isDisabled: propIsDisabled,
    onToggle,
    variant = "primary",
    className,
    headingWrapper,
    duration = 500
  } = props;
  const defaultId = useId();
  const id = propId != null ? propId : defaultId;
  const groupState = React.useContext(AccordionContext);
  const expanded = groupState ? (_a = groupState.expandedKeys) == null ? void 0 : _a.has(id) : propIsExpanded;
  const state = useDisclosureState({
    isExpanded: expanded,
    onExpandedChange: (isExpanded) => {
      if (groupState) {
        groupState.toggleKey(id);
      }
      onToggle == null ? void 0 : onToggle(isExpanded);
    }
  });
  const panelRef = React.useRef(null);
  const isDisabled = (_b = propIsDisabled != null ? propIsDisabled : groupState == null ? void 0 : groupState.isDisabled) != null ? _b : false;
  const { focusProps } = useFocusRing();
  const HeadingWrapper = headingWrapper != null ? headingWrapper : DefaultHeadingWrapper;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        width: "100%",
        className: accordionStyles({
          variant,
          className: `${className != null ? className : ""}`,
          isDisabled
        }),
        style: {
          transitionDuration: `${duration}ms`
        },
        ...mergeProps(props, focusProps),
        onClick: () => {
          state.toggle();
        },
        p: (_c = props.p) != null ? _c : DEFAULT_SPACING_PADDING,
        children: /* @__PURE__ */ jsxs(HeadingWrapper, { children: [
          /* @__PURE__ */ jsx(Fragment, { children: title }),
          /* @__PURE__ */ jsx(
            SvgArrowRight,
            {
              className: accordionArrowStyles({
                isExpanded: expanded,
                variant
              }),
              style: { transitionDuration: `${duration}ms`, minWidth: "24px" }
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        maxHeight: expanded ? "max-content" : 0,
        ref: panelRef,
        opacity: expanded ? 100 : 0,
        className: "overflow-hidden transition-all ease-in-out ",
        style: { transitionDuration: `${duration}ms` },
        children
      }
    )
  ] });
};
const AccordionContext = React.createContext(null);
const Accordion = ({
  children,
  ...props
}) => {
  const state = useDisclosureGroupState(props);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(AccordionContext.Provider, { value: state, children }) });
};
Accordion.Item = AccordionItem;
export {
  Accordion as A,
  AccordionContext as a,
  AccordionItem as b
};
